import { appendRelativeQuery } from "@/lib/analytics/funnel";

export type BlockerEntrySource =
  | "homepage"
  | "book"
  | "programs"
  | "courses"
  | "header"
  | "footer"
  | "blog_cta"
  | "unknown";

export function buildBlockerDiagnosticHref({
  sourcePage,
  sourceSection,
  sourceCta,
}: {
  sourcePage: BlockerEntrySource;
  sourceSection?: string;
  sourceCta?: string;
}) {
  return appendRelativeQuery("/find-your-blocker", {
    source_page: sourcePage,
    source_section: sourceSection,
    source_cta: sourceCta,
  });
}
